import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { BrowserDiagnosticsService } from 'src/app/common/diagnostics/browser-diagnostics.service';

export function diagnosticHttpInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const diagnostics = inject(BrowserDiagnosticsService, { optional: true });
    const diagnosticsEnabled = diagnostics?.isEnabled() === true;
    const scope = diagnostics?.start('http-request', 'http', {
        method: request.method,
        url: request.urlWithParams,
    });

    return next(request).pipe(
        tap({
            next: (event: HttpEvent<unknown>): void => {
                const body = 'body' in event ? event.body : null;

                if (diagnosticsEnabled && body != null) {
                    scope?.addMetric('responseSizeApprox', approximateSize(body), 'bytes');
                }
            },
            error: (error: unknown): void => {
                scope?.fail(error);
            },
            complete: (): void => {
                scope?.end();
            },
        }),
    );
}

function approximateSize(value: unknown): number {
    try {
        return new Blob([JSON.stringify(value)]).size;
    } catch {
        return 0;
    }
}
